import {LabwareSectionType} from 'constants/dataEnum';
import PropTypes from 'prop-types';
import {createWellColumnGenerator, getCombinedWellStyle} from 'contents/ProtocolEditor/VirtualTray/labwareHelper';
import React, {useMemo} from 'react';
import Divider from '../Divider';
import {SBTroughContainer, SBPlateTrough} from './spearBioLabwareDefinition';

const MAX_COLUMN = 8;

function TroughDivider() {
  return (
    <div className="well-divider-plain">
      <Divider divide={2} height="2px" color="#F5F5F5" margin={4} />
    </div>
  );
}

function SpearBioTroughWell({wellSections, wellStyle, labwareID, wellEventProps, wellCommonProps}) {
  const well = useMemo(() => {
    const WellColumnGenerator = createWellColumnGenerator({
      labwareID,
      wellEventProps,
      wellCommonProps,
      wellStyle,
    });

    const wellElements = wellSections.map((well) => {
      const {type, index} = well;

      if (type === LabwareSectionType.DIVIDER) {
        return <TroughDivider />;
      }

      const isShadowWell = type === LabwareSectionType.TROUGH;
      const generatedWells = WellColumnGenerator.generate(MAX_COLUMN, index);
      const troughStyle = isShadowWell ? getCombinedWellStyle(generatedWells.wellIDs, wellStyle) : {};

      return (
        <SBPlateTrough
          key={index}
          shadowWell={isShadowWell}
          background={troughStyle?.backgroundColor}
          borderColor={troughStyle?.borderColor}
          borderWidth={troughStyle?.borderWidth}
        >
          {generatedWells.component}
        </SBPlateTrough>
      );
    });

    return wellElements;
  }, [labwareID, wellCommonProps, wellEventProps, wellSections, wellStyle]);

  const numberOfRows = useMemo(
    () => wellSections.filter((well) => well.type !== LabwareSectionType.DIVIDER).length,
    [wellSections],
  );

  return <SBTroughContainer row={numberOfRows}>{well}</SBTroughContainer>;
}

SpearBioTroughWell.propTypes = {
  wellSections: PropTypes.array.isRequired,
  labwareID: PropTypes.string.isRequired,
  wellStyle: PropTypes.object,
  wellEventProps: PropTypes.object,
  wellCommonProps: PropTypes.object,
};

SpearBioTroughWell.defaultProps = {
  wellStyle: {},
  wellEventProps: {},
  wellCommonProps: {},
};

export default SpearBioTroughWell;
